import React from 'react';
import { trackPhoneClick } from '../../lib/analytics';

interface TrackedPhoneLinkProps {
  phoneNumber?: string;
  location: string;
  className?: string;
  children: React.ReactNode;
}

export function TrackedPhoneLink({
  phoneNumber = '(208) 328-4500',
  location,
  className,
  children
}: TrackedPhoneLinkProps) {
  const telHref = `tel:+1${phoneNumber.replace(/\D/g, '')}`;

  const handleClick = () => {
    trackPhoneClick(phoneNumber, location);
  };

  return (
    <a href={telHref} onClick={handleClick} className={className}>
      {children}
    </a>
  );
}
